import { useMemo, useState } from "react";
import { toast } from "sonner";
import { UserCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CustomerFormDialog } from "@/components/app/CustomerFormDialog";
import { EntityPicker, customerRender } from "@/components/app/EntityPicker";
import { useMe } from "@/components/app/MeContext";
import { api, errMsg } from "@/lib/api";

// Prospect -> customer: create the customer (normal form, duplicate checks) or link one that already exists.
export function ProspectConvert({ prospect, onDone }) {
  const { can } = useMe();
  const [open, setOpen] = useState(false);
  const [pick, setPick] = useState(null);
  const prefill = useMemo(() => ({ name: prospect.company_name, city: prospect.city, state: prospect.state, notes: prospect.notes,
    contacts: prospect.contact_name ? [{ name: prospect.contact_name, designation: "", phone: prospect.contact_phone, email: prospect.contact_email }] : undefined }), [prospect]);
  if (prospect.converted_customer_id) return (
    <div className="rounded border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-900" data-testid="prospect-converted-note">
      Converted to customer <b>{prospect.converted_customer_name}</b>. New quotations and LMs use the customer.
    </div>
  );
  if (!can("sales.convert")) return null;
  const link = async (cid) => {
    try { await api.post(`/prospects/${prospect.id}/link-customer`, { customer_id: cid }); toast.success("Prospect converted to customer"); onDone?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded border border-slate-200 bg-slate-50 p-3 space-y-2" data-testid="prospect-convert">
      <div className="text-xs font-semibold text-slate-700">Convert to customer</div>
      <div className="flex flex-wrap gap-2 items-center">
        {can("customers.create") && <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="prospect-create-customer-btn"><UserCheck className="h-4 w-4 mr-1" />Create customer from prospect</Button>}
        <span className="text-xs text-slate-500">or link an existing one:</span>
        <div className="min-w-[240px] flex-1"><EntityPicker url="/customers?active=true" value={pick} onChange={setPick} render={customerRender} placeholder="Pick customer" testid="prospect-link-customer-picker" /></div>
        <Button size="sm" disabled={!pick} onClick={() => link(pick.id)} data-testid="prospect-link-customer-btn">Link</Button>
      </div>
      {open && <CustomerFormDialog open={open} onOpenChange={setOpen} prefill={prefill} onSaved={(c) => link(c.id)} />}
    </div>
  );
}
